import axiosInstance from '../axiosInterceptor/axiosInstance'

const createCompetition = async ({ orgId, data }) => {
  const url = `v1/orgs/${orgId}/competitions`
  const response = await axiosInstance.post(url, JSON.stringify(data))
  return response?.data
}

export default createCompetition
